import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";

import "material-icons/iconfont/material-icons.scss";
import "flag-icon-css/sass/flag-icon.scss";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "./assets/scss/_index.scss";

import "./plugins/async-computed";
import "./plugins/axios";
import "./plugins/bootstrap-vue";
import "./plugins/casl-vue";
import "./plugins/v-calendar";
import "./plugins/vee-validate";
import "./plugins/vue-sweetalert2";
import "./plugins/v-select";
import "./plugins/vue2-filters";

import App from "./App.vue";
import "./registerServiceWorker";

import { prepareI18n, i18n } from "./i18n";
import { useRouter } from "./router";
import { useStore } from "./store";
import { prepareServices } from "./services";

export const store = useStore();
const router = useRouter(store);
prepareServices(store);
prepareI18n(store);

Vue.directive("capitalize", {
  update(el: any) {
    const event = new Event("input", { bubbles: true });
    el.value = el.value ? el.value.toString().charAt(0).toUpperCase() + el.value.slice(1) : "";
    el.dispatchEvent(event);
  },
});

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
